export default __webpack_public_path__ + "assets/Nicole_Headshot_low_res.9e2ac00d.jpg";